<template>
  <div class="footer">
    <div class="container footer-info">
      <div class="company-name">
        <img src="@/assets/logo/logo.png" alt="" />
        <div class="name">
          <p>晟科信息技术有限公司</p>
          <p>SHENGKE INFORMATION.CO.LTD</p>
        </div>
      </div>
      <div class="company-info">
        <div>
          <p class="company-address">地址：厦门市思明区软件园二期观日路32号303室18区</p>
          <p class="company-phone">电话：0592-3302799</p>
          <p class="company-email">邮箱：xmshengke@126.com</p>
        </div>
        <div class="company-qrcode">
          <img src="@/assets/image/qrcode.png" alt="" />
          <span>关注晟科</span>
        </div>
      </div>
    </div>
    <hr />
    <div class="container footer-authorization">
      <span>copyright©2021 晟科信息技术有限公司.All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  margin-top: 3.125rem /* 50/16 */;
  background-color: #fafafa;
  &-info {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.5s;
    .company-name {
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem /* 30/16 */;
      img {
        width: 3.75rem /* 60/16 */;
        margin-right: 0.9375rem /* 15/16 */;
      }
      .name {
        p {
          color: #333333;
          margin: 0;
          font-weight: bold;
          font-size: 1rem;
          letter-spacing: 0.1em;
        }
        p:nth-of-type(1) {
          font-size: 1.7rem /* 25/16 */;
          margin-bottom: 0.3125rem /* 5/16 */;
        }
      }
    }
    .company-info{
      display: flex;
    }
    .company-qrcode {
      margin-left: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 5rem /* 80/16 */;
      }
      span {
        font-size: 0.75rem /* 12/16 */;
      }
    }
    .company-address,
    .company-phone,
    .company-email {
      margin-top: 0.625rem /* 10/16 */;
      font-size: 0.8125rem /* 13/16 */;
    }
  }
  hr {
    border: 0.03125rem /* 0.5/16 */ solid #efefef;
  }
  &-authorization {
    padding: 1rem 0;
    font-size: 0.625rem /* 10/16 */;
    text-align: center;
  }
}
/*媒体查询*/
/*屏幕宽度小于878px的时候执行里面的css*/
@media only screen and (max-width: 1024px) {
  .footer-info {
    padding-left: 1.875rem /* 30/16 */;
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-authorization {
    padding: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/layout/footer/index.vue